import React from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import NotFoundPage from '../../NotFound/NotFoundPage'

const SwitchWithRoutes = ({ routes, notFound, resourceNotFound }) => (
  <Switch>
    {resourceNotFound
      ? <Route component={NotFoundPage} />
      : routes.map((route, i) => (
        <Route
          key={i}
          path={route.pattern}
          exact={route.exactly}
          strict={route.strict}
          render={props => (
            <route.component
              {...props}
              routes={route.routes
                ? Object.keys(route.routes).map(key => route.routes[key])
                : []
              }
            />
          )}
        />
      ))
    }
    {notFound && !resourceNotFound && <Route component={NotFoundPage} />}
  </Switch>
)
SwitchWithRoutes.defaultProps = {
  notFound: null,
  resourceNotFound: false,
}
SwitchWithRoutes.propTypes = {
  routes: PropTypes.array.isRequired,
  notFound: PropTypes.any,
  resourceNotFound: PropTypes.bool,
}

export default SwitchWithRoutes



// WEBPACK FOOTER //
// ./src/browser/components/routing/SwitchWithRoutes.js